module.exports = __webpack_public_path__ + "img/icon-motul.4260ca7e.png";